import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    mediaType: 'none', // 'none' | 'image' | 'video' | 'document' | 'audio'
    mediaFile: null, // { name, type, file, preview }
    mediaPreview: '', // Base64 preview for display
    error: '',
};

const mediaSlice = createSlice({
    name: 'media',
    initialState,
    reducers: {
        setMediaType: (state, action) => {
            state.mediaType = action.payload;
            // Reset media when changing type
            if (action.payload === 'none') {
                state.mediaFile = null;
                state.mediaPreview = '';
                state.error = '';
            }
        },
        setMediaFile: (state, action) => {
            const { file, preview } = action.payload;
            state.mediaFile = {
                file: file,
                preview: preview,
            };
            state.mediaPreview = preview;
            state.error = '';
        },
        clearMedia: (state) => {
            state.mediaType = 'none';
            state.mediaFile = null;
            state.mediaPreview = '';
            state.error = '';
        },
        setMediaError: (state, action) => {
            state.error = action.payload;
        },
        resetMediaError: (state) => {
            state.error = '';
        },
    },
});

export const {
    setMediaType,
    setMediaFile,
    clearMedia,
    setMediaError,
    resetMediaError,
} = mediaSlice.actions;

export default mediaSlice.reducer;
